import React, { useState, useEffect } from 'react';
import SeedFundSchemeLogo from '../../../images/SeedFundSchemeLogo.svg';
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
  useHistory,
} from 'react-router-dom';
import LoginComponent from '../../common/login/LoginComponent';
import ProfileContainer from '../../common/header/ProfileContainer';
import { getSessionStorageValue } from '../../../effects/utils/session-storage';
import { useAuthStateValue } from '../../../providers/AuthStateProvider';
import NotificationLogo from '../../../images/notifactions.svg';
import '../../../styles/dashboard.css';
import ApplyNowModalComponent from '../../common/header/ApplyNowModalComponent';
import { COUNT_SUBIMTTED, GET_APPLICATION_LIST, NOTIFICATION_LIST, NOTIFICATION_LIST_STATUS_CHANGE, NOTIFICATION_LIST_STATUS_CHANGE_ALL, SHOW_DASHBOARD } from '../../../constants/api';
import { get, post } from '../../../effects/api/api.common';
import { timeSince } from '../../../utils/CommonMethods';

function IncubatorHeaderComponent() {
  // @ts-ignore: Unreachable code error
  const [{ user }, dispatch] = useAuthStateValue();
  const [showDashboardFlag, setShowDashboardFlag] = useState(false);
  const [hideDashboard, sethideDashboard] = useState(false);
  const [notificationList, setNotificationList] = useState([])
  const [visibleMeeting,setVisibleMeeting] = useState(true)
  useEffect(() => {
    // showNotifications();
    showDashboardTab();
    checkSelectedApplication();
    if (user.accessToken) {
      const overlayElement = document.getElementById('overlay');
      if (!overlayElement) return;

      overlayElement.style.display = 'none';
    }
  }, [user]);
  const showDashboardTab = () => {
    get(SHOW_DASHBOARD).then((response: any) => {
      if (!response || !response.data) return;
      if (response.data.data=="true") {
        setShowDashboardFlag(true);
      }
      else{
        setShowDashboardFlag(false)
      }
      // console.log(response)
    });
  };
  const [isFundDetailsVisible, setIsFundDetailsVisible] = useState(false);

  const checkSelectedApplication = () => {
    get(GET_APPLICATION_LIST).then((response: any) => {
      if (!response || !response.data) return;


      if (response.data.length != 0) {
        const applicationList = response.data.map((item: any) => {
          if (item.status === 'Selected') {
            setIsFundDetailsVisible(true);

          }
        });
        response.data.map((item: any) => {
          if (item.status === 'Draft') {
            setVisibleMeeting(false);
          }
        });
      } else {
        setVisibleMeeting(false);
      }
    });
  };

  const showNotifications = () => {
    post(NOTIFICATION_LIST, '').then((response: any) => {
      if (!response || !response.data) return;
      setNotificationList(response.data.data)
    })
  }

  const statusChange = (id: any) => {
    post(NOTIFICATION_LIST_STATUS_CHANGE, { "id": id }).then((response: any) => {
      if (!response || !response.data) return;
      if (response.data.result == "success") {
        showNotifications()
      }
    })
  }
  const statusChangeAll = () => {
    post(NOTIFICATION_LIST_STATUS_CHANGE_ALL, '').then((response: any) => {
      if (!response || !response.data) return;
      if (response.data.result == "success") {
        showNotifications()
      }
    })
  }
  // @ts-ignore
  // @ts-ignore
  return (
    <header className="app-header header-sec">
      <nav className="navbar navbar-expand-lg navbar-dark fixed-top">
        <div className="container-fluid">
          <Link className="navbar-brand-dashboard mr-md-auto" to="/">
            <span aria-label="SISFS Logo" />
          </Link>

          {/* @* Hamburger menu code for responsive smaller screens *@ */}
          <button
            className="navbar-toggler"
            id="ChangeToggle"
            type="button"
            data-toggle="collapse"
            data-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <div id="navbar-hamburger">
              <span className="navbar-toggler-icon">
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </span>
            </div>
            <div id="navbar-close" className="hidden">
              <span className="fa fa-close"></span>
            </div>
          </button>

          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav m-auto">
              {/* {hideDashboard?  */}
              {showDashboardFlag && (
                <li className="nav-item">
                  {/* <Link role="menuitem" className="nav-link" to="/incubator_dashboard">
                  Dashboard
                </Link> */}
                  <NavLink
                    exact={true}
                    className="nav-link"
                    activeClassName="active"
                    to="/incubator_dashboard"
                  >
                    Dashboard
                  </NavLink>
                </li>
               )}
              {/* // :null}  */}

              <li role="none" className="nav-item dropdown">
                {/* <Link role="menuitem" className="nav-link" to="/incubator_status">
                  My Applications
                </Link> */}
                <NavLink
                  exact={true}
                  className="nav-link"
                  activeClassName="active"
                  to="/incubator_status"
                >
                  My Applications 
                </NavLink>
              </li>

              {visibleMeeting &&
              <li role="none" className="nav-item">
                <NavLink
                    exact={true}
                    className="nav-link"
                    activeClassName="active"
                    to="/incubator_meeting"
                >
                  Meetings
                </NavLink>
              </li>
              }

              {/* <li role="none" className="nav-item">

               <NavLink
                 exact={true}
                 className="nav-link"
                 activeClassName="active"
                 to={{
                  pathname: "/contact_incubator",
                  state: { selected_tab: "grievance" }

              }}
               >
                 Grievances
               </NavLink>
             </li> */}
              {isFundDetailsVisible === true ? (
                <li role="none" className="nav-item">
                  <NavLink
                    exact={true}
                    className="nav-link"
                    activeClassName="active"
                    to="/incubator_view_funddetails"
                  >
                    Fund Details
                  </NavLink>
                </li>
              ) : (
                ''
              )}
              {visibleMeeting &&
              <li role="none" className="nav-item">

                <NavLink
                    exact={true}
                    className="nav-link"
                    activeClassName="active"
                    to="/incubator_startup_list"
                >
                  Startups
                </NavLink>
              </li>
              }

              <li role="none" className="nav-item">

                <NavLink
                  exact={true}
                  className="nav-link"
                  activeClassName="active"
                  to="/incubator_grievances"
                >
                  Grievances
               </NavLink>
              </li>

              {/* <li role="none" className="nav-item">
              <a role="menuitem" className="nav-link">
                  Startups
                </a>
              </li> */}
            </ul>

            {/* Notification Code */}
            <div className="dropdown">
              <div className="media align-items-center pl-4" data-toggle="dropdown">
                <span className="avatar avatar-sm rounded-circle notification-bell" >
                  <img
                    src={NotificationLogo}
                    className="img-fluid"
                    alt="Notification Logo"
                  />
                </span>
                {notificationList.some((o: any) => o.read_status === 0) && <mark></mark>}
              </div>

              <ul className="dropdown-menu dropdown-menu-right notifications" role="menu" aria-labelledby="dLabel">

                <div className="notification-heading">
                  <h4 className="menu-title">Notifications</h4>
                  {notificationList.length != 0 && <span className="link-orange-text  pull-right" onClick={statusChangeAll}><u>Mark all as read</u></span>}
                </div>
                <li className="divider"></li>
                <div className="notifications-wrapper">
                  {notificationList.length == 0 && <a className="content">

                    <div className="notification-item">
                      <h4 className="item-title">No Notifications</h4>
                    </div>

                  </a>}
                  {notificationList.map((item: any,index) => (
                    <a key={index} className={item.read_status == 0 ? "content unread" : "content"} onClick={() => statusChange(item.id)}>

                      <div className="notification-item">
                        <h4 className="item-title">{item.message}</h4>
                        <p className="item-info">{timeSince(new Date(item.created_at))}</p>
                      </div>

                    </a>
                  ))}

                </div>

              </ul>
            </div>

            {/* <div className="media align-items-center pl-4">
              <span className="avatar avatar-sm rounded-circle">
                <img
                  src={NotificationLogo}
                  className="img-fluid"
                  alt="Notification Logo"
                />
              </span>
            </div> */}
            <div
              className="btn-group header-action-section"
              hidden={user?.accessToken ? true : false}
            >
              <a
                className="btn btn-sisfs btn-transparent-primary"
                data-toggle="modal"
                data-target="#LoginCollapse"
              // data-toggle="offcanvas"
              // to={
              //   !user.accessToken ? '/login' : '/'
              // } /*onToggle={toggleOffcanvas} /*to="/login"*/
              >
                Login
              </a>
            </div>
          </div>

          {/* <!-- Profile Section --> */}
          {user.accessToken && <ProfileContainer user={user} />}
        </div>
      </nav>

      {/* Offcanvas for Login screen */}
      {!user.accessToken && <LoginComponent />}
      {/* Offcanvas for Login screen */}
      <div className="hr">
        <hr />
      </div>
      <ApplyNowModalComponent />
    </header>
  );
}

export default IncubatorHeaderComponent;
